import { MantineProvider } from '@mantine/core';
import { NotificationsProvider } from '@mantine/notifications';
import React from 'react';
import ReactDOM from 'react-dom';
import { GoogleReCaptchaProvider } from 'react-google-recaptcha-v3';
import { BrowserRouter, Route, Routes } from 'react-router-dom';
import App from './App';
import { AuthProvider } from './contexts/auth-provider.context';
import './index.css';

if (window.top !== null && window.top !== window.self) {
  window.top.location.href = window.location.href;
}

ReactDOM.render(
  <React.StrictMode>
    <GoogleReCaptchaProvider
      reCaptchaKey={process.env.REACT_APP_RECAPTCHA_SITE_KEY ?? ''}
    >
      <MantineProvider
        withGlobalStyles
        withNormalizeCSS
        theme={{
          breakpoints: {
            xs: 280,
            sm: 400,
            md: 768,
            lg: 992,
            xl: 1200,
          },
        }}
      >
        <NotificationsProvider limit={5}>
          <BrowserRouter>
            <AuthProvider>
              <Routes>
                <Route path='/*' element={<App />} />
              </Routes>
            </AuthProvider>
          </BrowserRouter>
        </NotificationsProvider>
      </MantineProvider>
    </GoogleReCaptchaProvider>
  </React.StrictMode>,
  document.getElementById('root')
);
